"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Network;

(function (Network) {
  Network[Network["Unknown"] = 0] = "Unknown";
  Network[Network["Mainnet"] = 1] = "Mainnet";
  Network[Network["Ropsten"] = 2] = "Ropsten";
  Network[Network["Rinkeby"] = 3] = "Rinkeby";
  Network[Network["Kovan"] = 4] = "Kovan";
})(Network = exports.Network || (exports.Network = {}));

var NetworkUtils =
/** @class */
function () {
  function NetworkUtils() {}

  NetworkUtils.fromId = function (networkId) {
    if (networkId == 1) {
      return Network.Mainnet;
    }

    if (networkId == 3) {
      return Network.Ropsten;
    }

    if (networkId == 4) {
      return Network.Rinkeby;
    }

    return Network.Unknown;
  };

  return NetworkUtils;
}();

exports.NetworkUtils = NetworkUtils;